import { createPaginator } from "@smithy/core";
import { GetCelebrityRecognitionCommand, } from "../commands/GetCelebrityRecognitionCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateGetCelebrityRecognition = createPaginator(RekognitionClient, GetCelebrityRecognitionCommand, "NextToken", "NextToken", "MaxResults");
